import PropTypes from 'prop-types';
import React from 'react';
import {
    memberProptype,
    requestUserProptype,
} from '../../../Includes/GroupPropsShape';

import PendingUserRequest from '../../../Users/PendingUserRequest/PendingUserRequest';
import './MemberList.scss';

import MemberUser from './MemberUser/MemberUser';

export default class MemberList extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * The current menu item that user has selected
         */
        selectedMenuItem: PropTypes.string.isRequired,
        /**
         * The list of group's member data
         */
        memberUserList: PropTypes.arrayOf(memberProptype).isRequired,
        /**
         * The list of group's request user data
         */
        requestUserList: PropTypes.arrayOf(requestUserProptype).isRequired,
        /**
         * fetch for update member's memberType, ManageMember's state will be updated to reflects the change
         */
        handleUpdateMember: PropTypes.func.isRequired,
        /**
         * fetch for removing member, ManageMember's state will be updated to reflects the change
         */
        handleRemoveMember: PropTypes.func.isRequired,
        /**
         * fetch for processing join request, ManageMember's state will be updated to reflects the change
         */
        handleJoinRequest: PropTypes.func.isRequired,
    };

    static defaultProps = {
        selectedMenuItem: '',
        memberUserList: [],
        requestUserList: [],
        handleUpdateMember: () => {},
        handleRemoveMember: () => {},
        handleJoinRequest: () => {},
    };

    render() {
        const {
            selectedMenuItem,
            memberUserList,
            requestUserList,
            handleRemoveMember,
            handleUpdateMember,
            handleJoinRequest,
        } = this.props;

        switch (selectedMenuItem) {
            case 'Members':
                return (
                    <div className="component-Groups-ManageMembers-MemberList">
                        {!!memberUserList &&
                            memberUserList.map(
                                ({ user, groupMemberType }, index) => (
                                    <MemberUser
                                        key={`member-${index}`}
                                        user={user}
                                        groupMemberType={groupMemberType}
                                        handleRemoveMember={handleRemoveMember}
                                        handleUpdateMember={handleUpdateMember}
                                    />
                                )
                            )}
                    </div>
                );
            case 'Requests':
                return (
                    <div className="component-Groups-ManageMembers-MemberList">
                        {!!requestUserList &&
                            requestUserList.map(
                                ({ user, inviteQuestionAnswer }, index) => (
                                    <PendingUserRequest
                                        key={`request-${user.userId}`}
                                        user={user}
                                        bubbleMessage={inviteQuestionAnswer}
                                        handleRequest={handleJoinRequest}
                                    />
                                )
                            )}
                    </div>
                );
            default:
                return null;
        }
    }
}
